export default __webpack_public_path__ + "static/media/Mystic's Legguards of the Green Ones.5ff9544e.jpg";